import React from "react";
import colors from "tailwindcss/colors";

export default function RespondentCategorization(props: { responseRate: number; green: number; yellow: number; red: number; gray: number, totalRecipients: number, printable?: boolean }) {
  const { responseRate, green, yellow, red, gray, totalRecipients, printable } = props;

  const totalRespondents = green + yellow + red + gray;
  const data = [
    {
      value: red,
      color: colors.red[500],
      text: "Individuals experiencing extreme stress and dysfunction, significantly impairing performance, well-being, and overall functioning.",
      title: "At-Risk"
    },
    {
      value: yellow,
      color: colors.yellow[500],
      text: "Individuals experiencing higher than average levels of stress, unsustainable for long durations of time. Often associated with high levels of performance.",
      title: "Elevated"
    },
    {
      value: green,
      color: colors.green[600],
      text: " Individuals with varying degrees of optimal engagement, performance, and manageable stress levels.",
      title: "Optimized"
    },
    {
      value: gray,
      color: colors.gray[500],
      text: "Individuals who are disengaged, not invested, or under reporting current stress levels.",
      title: "Disengaged"
    },
  ];



  return (
    <div className={``}>
      <div className={`flex ${printable ? "flex-row justify-around" : "flex-col md:flex-row md:justify-around"} items-center`}>
        <div className="w-1/3 flex flex-col items-start p-4">
          <div className="bg-white border-2 border-black flex items-center justify-center h-24 w-24 mb-2">
            <h2 className={`${printable ? "mb-7" : ""} text-4xl font-bold`}>{totalRespondents}</h2>
          </div>
          <div className="">
            <div className="text-lg font-medium">Respondents</div>
            <div className="text-sm">{Math.round(responseRate)}% of {totalRecipients} participants</div>
          </div>
        </div>
        <div className={`grid ${printable ? "grid-cols-2" : "grid-cols-1 md:grid-cols-2"} gap-8`}>
          {data.map((item, index) => (
            <div key={index} className="flex items-center">
              <div
                className={`flex justify-center items-center border-2 h-16 w-16 bg-white`}
                style={{
                  borderColor: item.color,
                }}
              >
                <h2
                  className={`${printable ? "mb-6" : ""} px-7 text-2xl font-bold`}
                  style={{
                    color: item.color,
                  }}
                >
                  {item.value}
                </h2>
              </div>
              <div className="ml-4">
                <div className="flex items-center mb-2">
                  <p className={`text-md font-medium`} style={{color: item.color}}>{item.title}</p>
                  <p className="text-sm mx-2">|</p>
                  <p className="text-md font-extralight">{((item.value / totalRespondents) * 100).toFixed()}% of respondents</p>
                </div>
                <div className="">
                  <div className="text-sm">{item.text}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
